import { render, staticRenderFns } from "./InstitutionalDynamics.vue?vue&type=template&id=29dcc886&scoped=true"
import script from "./InstitutionalDynamics.vue?vue&type=script&lang=js"
export * from "./InstitutionalDynamics.vue?vue&type=script&lang=js"
import style0 from "./InstitutionalDynamics.vue?vue&type=style&index=0&id=29dcc886&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dcc886",
  null
  
)

export default component.exports